import PageTitle from '@/common/components/business/PageTitle';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2FormRangePicker from '@/common/components/Form/V2FormRangePicker/V2FormRangePicker';
import V2SearchForm from '@/common/components/Form/V2SearchForm';
import { isNotEmpty } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import dayjs from 'dayjs';
import { FC } from 'react';
import styles from './index.module.less';

/**
 * @Description
 */
const Filter:FC<{setSearchParams, searchForm}> = ({ setSearchParams, searchForm }) => {

  const methods = useMethods({
    onSearch(values) {
      setSearchParams(values);
    }
  });
  return (
    <div>
      <PageTitle content={<div className={styles.title}>
        文件导出管理
        <div className={styles.tip}>(导出文件在生成后可保留30天)</div>
      </div>}/>
      <V2SearchForm onSearch={methods.onSearch} form={searchForm}>
        <V2FormInput label='文件名称' name='fileName'/>
        <V2FormRangePicker label='操作时间' name='time' formItemConfig={{
          getValueFromEvent: (...[, dateString]) => Array.isArray(dateString) && dateString.filter(item => isNotEmpty(item)).length ? dateString : [],
          getValueProps: (value) => ({ value: Array.isArray(value) && value.filter(item => isNotEmpty(item)).length ? [dayjs(value[0], 'YYYY-MM-DD'), dayjs(value[1], 'YYYY-MM-DD')] : undefined })
        }}/>
      </V2SearchForm>
    </div>
  );
};

export default Filter;
